import { useState, useCallback } from 'react';
import apiService from './index';
import { ApiServiceErrorCallBack } from './interface';


export const useApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  /**
   * Make a GET request using the API service
  */
  const get = useCallback(async <S, F>(
    apiPath: string,
    headers: any,
    options?: {
      loading?: boolean, 
      authorized?: boolean;
      onSuccess?: (data: S) => void;
      onError?: (error: ApiServiceErrorCallBack<F>) => void;
    }
  ) => {
    if ( options?.loading || options?.loading === undefined ) setLoading(true);
    setError(null);
    
    return apiService.getRequest<S, F>({
      apiPath,
      headers,
      authorized: options?.authorized !== false, // Default to true
      loadingCallBack: ( options?.loading || options?.loading === undefined ) ? () => setLoading(true) : undefined,
      successCallBack: (data) => {
        if (options?.onSuccess) {
          options.onSuccess(data);
        }
      },
      errorCallBack: (error) => {
        setError(error);
        if (options?.onError) {
          options.onError(error);
        }
      },
      onFinallyCallBack: () => setLoading(false)
    });
  }, []);

  /**
   * Make a POST request using the API service
   */
  const post = useCallback(async <S, T>(
    apiPath: string,
    postObject: FormData,
    headers: any,
    options?: {
      method?: "POST" | "PUT" | "PATCH" | "DELETE";
      showSuccess?: boolean;
      showError?: boolean;
      onSuccess?: (data: S) => void;
      onError?: (error: ApiServiceErrorCallBack<T>) => void;
    }
  ) => {
    setLoading(true);
    setError(null);
    
    return apiService.postRequest<S, T>({
      apiPath,
      postObject,
      headers,
      method: options?.method || 'POST',
      showSuccess: options?.showSuccess !== false, // Default to true
      showErrror: options?.showError !== false, // Default to true
      loadingCallBack: () => setLoading(true),
      successCallBack: (data) => {
        if (options?.onSuccess) {
          options.onSuccess(data);
        }
      },
      errorCallBack: (error) => {
        setError(error);
        if (options?.onError) {
          options.onError(error);
        }
      },
      onFinallyCallBack: () => setLoading(false)
    });
  }, []);

  return {
    loading,
    error,
    get,
    post,
    apiService
  };
};

export default useApi;
